import { serializable, object, primitive, alias } from 'serializr';
import { ParentCompanySetup } from './parentCompanySetup.model';
import { Organization } from './organization.model';

export class OrganizationDataModel {
  @serializable(object(Organization))
  organization?: Organization;

  @serializable(object(ParentCompanySetup))
  company?: ParentCompanySetup;
}
